import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeScreen from '@/views/HomeScreen'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeScreen
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
